export enum BannerType {
  ARTICLE = 'article',
  CATEGORY = 'category',
}
